export default [
  {
    id: 'PERSONAL_INFO',
    name: 'Personal Information',
    desc: 'Manage details such as name or password',
    route: 'Frontastic.Frontend.Master.Account.profile',
    pathname: '/account/profile',
  },
  {
    id: 'ADDRESS_BOOK',
    name: 'Address Book',
    desc: 'Change delivery or billing address',
    route: 'Frontastic.Frontend.Master.Account.addresses',
    pathname: '/account/addresses',
  },
  {
    id: 'ORDERS',
    name: 'Orders',
    desc: 'Track and manage your orders.',
    route: 'Frontastic.Frontend.Master.Account.orders',
    pathname: '/account/orders',
  },
  {
    id: 'WISHLIST',
    name: 'Wishlist',
    desc: 'Manage all your products in your wishlist',
    route: 'Frontastic.Frontend.Master.Account.wishlists',
    pathname: '/account/wishlists',
  },
  {
    id: 'SUBS_PREFER',
    name: 'Subscription Preferences',
    desc: 'Manage your subscriptions via an external portal ',
    pathname: null,
  },
  {
    id: 'LOGOUT',
    name: 'Log out',
    pathname: null,
    desc: null,
  },
];
